// src/utils/pdfExtractor.js - LEGACY VERSION (Most Reliable)
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry';

// Set worker using the bundled entry point
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export const extractTextFromPDF = async (file) => {
  try {
    if (!file.type.includes('pdf')) {
      throw new Error('Please upload a valid PDF file');
    }
    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      throw new Error('PDF file is too large. Maximum size is 10MB');
    }

    const arrayBuffer = await file.arrayBuffer();
    const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
    const pdf = await loadingTask.promise;

    console.log(`PDF loaded. Total pages: ${pdf.numPages}`);

    let fullText = '';
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const textContent = await page.getTextContent();
      const pageText = textContent.items.map(item => item.str).join(' ');
      fullText += pageText + '\n\n';
      console.log(`Extracted page ${pageNum}/${pdf.numPages}`);
    }

    fullText = fullText
      .replace(/\s+/g, ' ')
      .replace(/\n\s*\n/g, '\n\n')
      .trim();

    if (!fullText || fullText.length < 10) {
      throw new Error('No text content found in PDF. The PDF might be image-based or empty.');
    }

    console.log(`Successfully extracted ${fullText.length} characters from PDF`);
    return fullText;

  } catch (error) {
    console.error('PDF extraction error:', error);
    if (error.message.includes('Invalid PDF')) {
      throw new Error('Invalid PDF file. Please make sure the file is not corrupted.');
    }
    if (error.message.includes('password')) {
      throw new Error('This PDF is password-protected. Please use an unprotected PDF.');
    }
    throw new Error(error.message || 'Failed to extract text from PDF. Please try again.');
  }
};